/* Combobox remoto de dominios, filtrable por tipo y padre (cascada) */
import { useLazyQuery } from "@apollo/client";
import React, { useMemo, useState } from "react";
import { SelectProps } from "antd";
import { DOMAINSGENERAL } from "./ComboboxGQL";
import RemoteComboBox from "../../../shared/RemoteComboBox";
import { normalizeKey } from "../../../shared/verteoffice/exports/helpers/helpers";

interface DomainComboboxProps extends SelectProps<string> {
    pageSize?: number;
    type?: string;
    parentid?: string;
}

export const matchesNormalizedDomainOption = (input: string, optionLabel: unknown): boolean =>
    normalizeKey(String(optionLabel ?? '')).includes(normalizeKey(input));

const DomainCombobox: React.FC<DomainComboboxProps> = ({
    pageSize = -1,
    type,
    parentid,
    ...props
}) => {
    const [searchValue, setSearchValue] = useState("");
    const DEFAULT_VARIABLES = parentid ? {
        type,
        parentid,
    } : {
        type,
    };

    const [getData, { data, loading, error }] = useLazyQuery(
        DOMAINSGENERAL,
        {
            fetchPolicy: "no-cache",
            variables: {
                ...DEFAULT_VARIABLES,
                search: "",
                combo: true,
                table: false
            },
        }
    );

    const fetchData = (options: any) => {
        const { search, ...rest } = options.variables ?? {};
        setSearchValue(String(search ?? ""));
        getData({
            variables: {
                ...rest,
                search: "",
            },
        });
    };

    const filteredData = useMemo(() => {
        const allDomains = data?.domains ?? [];
        if (!searchValue.trim()) {
            return allDomains;
        }

        return allDomains.filter((domain: { name?: string }) =>
            matchesNormalizedDomainOption(searchValue, domain?.name)
        );
    }, [data?.domains, searchValue]);

    return (
        <RemoteComboBox
            {...props}
            optionIdKey={"name"}
            optionValueKey={"name"}
            pageSize={pageSize}
            defaultVariables={DEFAULT_VARIABLES}
            fetchData={fetchData}
            data={{ domains: filteredData }}
            dataKey={"domains"}
            loading={loading}
            error={error}
            addDropRender
        />
    );
};

export default DomainCombobox;
